import React from 'react';
import { Box, Typography } from '@mui/material';
import { resolveSlotValues, getDTWidgetSlots } from '../../registry/dtWidgetTypes';
import { useDTDemoMap } from '../../hooks/useDTDemoTick';
import { hasLiveSlotValue } from '../../utils/dtDemoFallback';
import { dtWidgetFilledColumnSx } from '../../styles/dtWidgetStyleTokens';

const DEFAULT_SLOTS = getDTWidgetSlots('dt-temperature-grid');

function DTTemperatureGrid({ widget, data, theme }) {
  const isDark = theme === 'dark';
  const tagprops = widget?.props?.extended?.tagprops || [];
  const liveData = Array.isArray(data) ? data : [];
  const slotValues = resolveSlotValues(tagprops, liveData);
  const demoMap = useDTDemoMap('dt-temperature-grid');

  const cells = DEFAULT_SLOTS.map((slot) => {
    const resolved = slotValues[slot.key];
    const liveOk = hasLiveSlotValue(resolved);
    const demoVal = demoMap[slot.key];
    return {
      label: resolved?.alias || slot.label,
      value: liveOk ? resolved.value : demoVal ?? '—',
    };
  });

  return (
    <Box sx={{ ...dtWidgetFilledColumnSx, px: 1 }}>
      <Typography variant="subtitle2" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 700, mb: 0.5, flexShrink: 0 }}>
        Temperature (°C)
      </Typography>
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gridTemplateRows: 'repeat(3, minmax(0, 1fr))',
          gap: 1,
          overflow: 'hidden',
        }}
      >
        {cells.map((cell) => (
          <Box
            key={cell.label}
            sx={{
              padding: 0.75,
              border: `1px solid ${isDark ? '#505050' : '#ccc'}`,
              backgroundColor: isDark ? '#111' : '#f5f5f5',
              borderRadius: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              minHeight: 0,
              minWidth: 0,
            }}
          >
            <Typography variant="caption" sx={{ color: isDark ? '#aaa' : '#555', display: 'block', lineHeight: 1.2 }}>
              {cell.label}
            </Typography>
            <Typography variant="h6" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 700, lineHeight: 1.15 }}>
              {cell.value !== '—' ? `${cell.value} °C` : '—'}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default React.memo(DTTemperatureGrid);
